import { ActionReducerMap } from '@ngrx/store';
import { TEmployeeListState } from './employee-list/employee-list.models';
import { TFactoryListState } from './factory-list/factory-list.models';
import * as fromFactoryListReducer from './factory-list/factory-list.reducer';
import { TNavigationState } from './navigation/navigation.models';
import * as fromNavigationReducer from './navigation/navigation.reducer';
import { TLearningCurveState } from './learning-curve/learning-curve.models';
import * as fromLearningCurveReducer from './learning-curve/learning-curve.reducer';
import { TFactoryShiftState } from './factory-shift/factory-shift.models';
import * as fromFactoryShiftReducer from './factory-shift/factory-shift.reducer';
import * as employeeListReducer from './employee-list/employee-list.reducer';
import * as fromFactoryProductLineEfficiencyReducer from './product-line-efficiency/product-line-efficiency.reducer';
import { TFactoryProductLineEfficiencyState } from './product-line-efficiency/product-line-efficiency.models';
import { TTnaTemplateState } from './tna-templates/tna-templates.models';
import * as fromTnaTemplateReducer from './tna-templates/tna-templates.reducer';
import { TOrderAttributesState } from './order-attributes/order-attributes.models';
import * as fromOrderAttributesReducer from './order-attributes/order-attributes.reducer';
import { TOrderListState } from './order-list/order-list.models';
import * as fromOrderListReducer from './order-list/order-list.reducer';
import { TTnAOrderTemplateState } from './tna-order-template/tna-order-template.models';
import * as fromTnAOrderTemplateReducer from './tna-order-template/tna-order-template.reducer';
import { TOrderDetailsState } from './order-details/order-details.models';
import * as fromOrderDetailsReducer from './order-details/order-details.reducer';
import * as tnaBoardReducer from './tna-board/tna-board.reducer';
import { TTnaBoardState } from './tna-board/tna-board.models';
import * as fromTnaUpdateReducer from './tna-updates/tna-updates.reducer';
import { TTnaUpdateState } from './tna-updates/tna-updates.models';
import { TLLBoardState } from './ll-board/ll-board.models';
import * as llBoardReducer from './ll-board/ll-board.reducer';
import { THLBoardState } from './hl-board/hl-board.models';
import * as hlBoardReducer from './hl-board/hl-board.reducer';
import { TFactoryConfigState } from './factory-config/factory-config.models';
import * as fromFactoryConfigReducer from './factory-config/factory-config.reducer';
import { TTnaApprovalsState } from './tna-approvals/tna-approvals.models';
import * as fromTnaApprovalsReducer from './tna-approvals/tna-approvals.reducer';
import { TOrderChecklistState } from './order-checklist/order-checklist.models';
import * as fromOrderChecklistReducer from './order-checklist/order-checklist.reducer';
import { TProcessMappingState } from './process-mapping/process-mapping.models';
import * as fromProcessMappingReducer from './process-mapping/process-mapping.reducer';
import { TProcessBoardsState } from './process-boards/process-boards.models';
import * as fromProcessBoardsReducer from './process-boards/process-boards.reducer';

export type TPlani8State = {
  navigationInfo: TNavigationState;
  factoryListInfo: TFactoryListState;
  factoryConfigInfo: TFactoryConfigState;
  learningCurvesInfo: TLearningCurveState;
  factoryShiftInfo: TFactoryShiftState;
  employeeListInfo: TEmployeeListState;
  factoryProductLineEfficiencyInfo: TFactoryProductLineEfficiencyState;
  tnaTemplateInfo: TTnaTemplateState;
  orderAttributesInfo: TOrderAttributesState;
  orderListInfo: TOrderListState;
  tnaOrderTemplateInfo: TTnAOrderTemplateState;
  orderDetailsInfo: TOrderDetailsState;
  tnaBoardInfo: TTnaBoardState;
  tnaUpdateState: TTnaUpdateState;
  tnaApprovalsState: TTnaApprovalsState;
  llBoardInfo: TLLBoardState;
  hlBoardInfo: THLBoardState;
  orderChecklistInfo: TOrderChecklistState;
  processMappingInfo: TProcessMappingState;
  processBoardsState: TProcessBoardsState;
};

export const plani8Reducer: ActionReducerMap<TPlani8State, never> = {
  navigationInfo: fromNavigationReducer.navigationReducer,
  factoryListInfo: fromFactoryListReducer.factoryListReducer,
  factoryConfigInfo: fromFactoryConfigReducer.factoryConfigReducer,
  learningCurvesInfo: fromLearningCurveReducer.learningCurveReducer,
  factoryShiftInfo: fromFactoryShiftReducer.factoryShiftReducer,
  employeeListInfo: employeeListReducer.employeeListReducer,
  factoryProductLineEfficiencyInfo: fromFactoryProductLineEfficiencyReducer.factoryProductLineEfficiencyReducer,
  tnaTemplateInfo: fromTnaTemplateReducer.tnaTemplatesReducer,
  orderAttributesInfo: fromOrderAttributesReducer.orderAttributesReducer,
  orderListInfo: fromOrderListReducer.orderListReducer,
  tnaOrderTemplateInfo: fromTnAOrderTemplateReducer.tnaOrderTemplateReducer,
  orderDetailsInfo: fromOrderDetailsReducer.orderListReducer,
  tnaBoardInfo: tnaBoardReducer.tnaBoardReducer,
  tnaUpdateState: fromTnaUpdateReducer.tnaStepsReducer,
  tnaApprovalsState: fromTnaApprovalsReducer.tnaApprovalsReducer,
  llBoardInfo: llBoardReducer.llBoardReducer,
  hlBoardInfo: hlBoardReducer.hlBoardReducer,
  orderChecklistInfo: fromOrderChecklistReducer.orderChecklistReducer,
  processMappingInfo: fromProcessMappingReducer.processMappingReducer,
  processBoardsState: fromProcessBoardsReducer.processBoardsReducer,
};
